export const groupCodeConstants = {
  API_BASE_PATH: '/v1/documents/group_codes',
  GET_GROUP_CODES: 'GET_GROUP_CODES',
};
